import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#303f9f",
		},
		secondary: {
			main: "#ffd740",
		},
	},
});

export default theme;
